import functionalUtils from './functional-utils.js';
import { advancedLocalStorage } from '@sendible/common';

function checkForCookieAndCreateLocalStorageItem(key) {
  const doesExistInLocalStorage = advancedLocalStorage.getItem(key);

  if (doesExistInLocalStorage) {
    return key;
  }

  const cookieValue = js_Cookie.get(key);

  if (!cookieValue) {
    return key;
  }

  advancedLocalStorage.setItem(key, cookieValue);

  js_Cookie.remove(key);

  return key;
}

function getCookieOrLocalStorageItem(key) {
  return functionalUtils.pipe([
    checkForCookieAndCreateLocalStorageItem,
    advancedLocalStorage.getItem,
  ])(key);
}

export default {
  checkForCookieAndCreateLocalStorageItem,
  getCookieOrLocalStorageItem,
};
